import React from 'react';
import {
  initMercadoPago,
  CardPayment as CPMercadopago,
} from '@mercadopago/sdk-react';
initMercadoPago(window.AppENV.mercadopagoPK);

const CardPayment = ({ email, amount, onSubmit }) => {
  

  return (
    <CPMercadopago
      initialization={{
        amount,
        payer: {
          email,
        },
      }}
      
      locale='es-AR'
      onSubmit={onSubmit}
      customization={{
        visual: {
          texts: {
            formSubmit: 'Contratar',
          },
          style: {
            theme: 'dark',
            customVariables: {
              formBackgroundColor: '#141414',
              baseColor: '#FFB500',
              outlineSecondaryColor: '#FFB500',
            },
          },
          
        },
        paymentMethods: {
          maxInstallments: 1,
        },
      }}
    />
  );
};

export default React.memo(CardPayment);
